//https://img-api.rpd.ink
//https://i.rpd.ink

const Config = {
    view_base: "https://img.rpd.ink",
    api_base: "https://img-api.rpd.ink",
    image_base: "https://i.rpd.ink"
}
export default Config;
